const CAPTION = "image-caption";
export {
  CAPTION
};
//# sourceMappingURL=data-hooks.js.map
